export default {
  MODAL: 'MODAL',
} as const
